"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoeTranslation = void 0;
class PoeTranslation {
    constructor(translation) {
        var _a;
        if (!translation) {
            return;
        }
        const { term, definition: poeDefinition } = translation;
        this.key = term;
        if (poeDefinition) {
            if (typeof poeDefinition !== "string") {
                const definition = poeDefinition;
                this.translation = definition.one;
                this.translationPlural = (_a = definition.other) !== null && _a !== void 0 ? _a : "";
            }
            else {
                this.translation = poeDefinition;
                this.translationPlural = "";
            }
        }
    }
}
exports.PoeTranslation = PoeTranslation;
